import React from 'react';
import infoIcon from '@assets/icons/information-icon.svg';
import groupTaskConst from 'FielderUtils/roleManagementConst/groupTasksConst';
import GroupStatus from 'FielderUtils/status/groupTaskStatus';
import { useLanguage } from 'Context/LanguageContext';
import useValidateRoles from '@core/utils/roles/useValidateRoles';
import Loading from '~/FielderElements/Loading/Loading';
import { EditNote, FileDownload, LinkOff, PermMedia } from '@mui/icons-material';
import { Box, Typography, IconButton, Tooltip, Stack } from '@mui/material';

const EditGroupTaskTitle = (props) => {
  const lan = useLanguage();
  const { isRoleValid } = useValidateRoles();
  const canDownloadGroupTaskImages = isRoleValid(groupTaskConst.GROUPTASK, groupTaskConst.DOWNLOAD_TASK_IMAGES);
  const canEditGroupTask = isRoleValid(groupTaskConst.GROUPTASK, groupTaskConst.EDIT);
  const canExportGroupTasks = isRoleValid(groupTaskConst.GROUPTASK, groupTaskConst.EXPORT_TASKS);
  const canUnlinkGroupTask = isRoleValid(groupTaskConst.GROUPTASK, groupTaskConst.UNLINK);
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 0.5,
      }}
    >
      {/* Title */}
      <Typography
        variant="subtitle1"
        className="Fielder-modal-popUp-title"
        sx={{ mr: 1, whiteSpace: 'nowrap' }}
      >
        {props.titleBranch}
      </Typography>

      {/* Left actions / loader */}
      {props.loadingActive ? (
        <Box sx={{ ml: 1 }}>
          <Loading inline size="40px" thickness={1} />
        </Box>
      ) : (
        <Stack direction="row" spacing={1} alignItems="center">
          {props.tab === 'infoTaskGroup' && (
            <>
              {GroupStatus.FINISH_NAME !== props.status && canEditGroupTask && (
                <Tooltip title={lan.edit}>
                  <IconButton onClick={props.handleEdit} size="small">
                    <EditNote />
                  </IconButton>
                </Tooltip>
              )}

              {canDownloadGroupTaskImages && (
                <Tooltip title={lan.downloadImages || lan.download}>
                  <IconButton onClick={props.handleDownloadImage} size="small">
                    <PermMedia />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}

          {props.tab === 'taskInfo' && (
            <>
              {canExportGroupTasks && (
                <Tooltip title={lan.export}>
                  <IconButton onClick={props.showExportTask} size="small">
                    <FileDownload />
                  </IconButton>
                </Tooltip>
              )}

              {canUnlinkGroupTask && (
                <Tooltip title={lan.unlinkTaskGroup}>
                  <IconButton onClick={props.handleUnlinkTask} size="small">
                    <LinkOff />
                  </IconButton>
                </Tooltip>
              )}

              {props.showTooltip && (
                <Box sx={{ px: 1 }}>
                  <div className="tooltipCustomProgram">
                    <img src={infoIcon} alt="" />
                    <span className="tooltiptextCustomProgram">{lan.selectTasks}</span>
                  </div>
                </Box>
              )}

              {props.showTooltipFinishTask && (
                <Box sx={{ px: 1 }}>
                  <span className="text-format-task-finish">{lan.selectTasksFinish}</span>
                </Box>
              )}
            </>
          )}
        </Stack>
      )}

      {/* Spacer pushes counter to the far right */}
      <Box sx={{ flex: 1 }} />

      {/* Right counter */}
      <Box>
        <span className="text-format-task-finished">
          {lan.taskFinished}: {props.countNumberFinish}
        </span>
      </Box>
    </Box>
  );
};

export default EditGroupTaskTitle;
